import { useState } from 'react'
import styles from './TextButton.module.scss'

export interface ProcessingTextButtonProps {
	title: string;
	processingMethod: () => Promise<any>;
}

export const ProcessingTextButton = (props: ProcessingTextButtonProps) => {
	const [isProcessing, setIsProcessing] = useState(false);

	async function process() {
		setIsProcessing(true);

		try {
			await props.processingMethod();
		}
		catch {
			alert('Не удалось обработать действие, попробуйте позже')
		}
		finally {
			setIsProcessing(false);
		}
	}

	return (
		<button className={styles.button} onClick={() => process()}>
			{
				isProcessing
					? <i className="fas fa-spinner fa-spin"></i>
					: props.title
			}
		</button>
	)
}